<template>
  <v-card
    :id="cardElementId"
    class="d-flex flex-column align-start mt-3 bg-surface hover-container w-100 ml-6"
    style="max-width: calc(100% - 24px);"
  >
    <v-card-text
      class="card-item-body rounded-lg pa-1 hover-container"
      :style="{ 'border-color': borderColor }"
    >
      <div :id="`${childEntity.id}-lvl3-${parentEntity.id}`" class="d-flex justify-space-between align-center ga-2 mb-1">
        {{ childEntity.name }}
        <div class="show-on-hover pe-2">
          <edit-entity :entity="childEntity" :refreshKey="refreshKey" />
        </div>
      </div>
      <template v-if="showEntities">
        <v-divider thickness="2" style="width: 100%;"></v-divider>
        <template v-for="(field, index) in childEntity.fields" :key="index">
          <div
            v-if="field && field.name"
            class="field-name d-flex align-center"
          >
            <quick-rename-input
              :id="`entity-${childEntity.id}-lvl3-field-${index}`"
              :value="field.name"
              @onChange="(e) => emit('field-blur', e, childEntity, index)"
              :density="`compact`"
              :max-length="30"
              class="flex-1-0"
              :class="{
                'required-field': field.tags?.includes('REQUIRED')
              }"
              :disabled="store.state.isWorkflowDisabled"
            />
            <span v-if="dataTypeLabel(field)" class="data-type-label">{{ dataTypeLabel(field) }}</span>
            <v-chip v-if="field.relatedEntityId && getRelatedEntity(field)" density="compact" size="small" class="px-2 ml-1">
              {{ field.cardinality === 'one-to-many'
                ? `[ ${getRelatedEntity(field)?.name} ]`
                : `${getRelatedEntity(field)?.name}` }}
            </v-chip>
          </div>
        </template>
      </template>
      <div class="pt-1">
        <workflow-aggregate-select-bounded-context
          :entity="childEntity"
          :boundedContext="boundedContext"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { useStore } from 'vuex'
import EditEntity from '@/components/EditEntity'
import QuickRenameInput from '@/components/QuickRenameInput'
import WorkflowAggregateSelectBoundedContext from '@/components/WorkflowAggregateSelectBoundedContext'
import useDomainModel from '@/composables/useDomainModel'
import { DataTypeShortLabels } from '@/constants/schema'

defineProps({
  childEntity: { type: Object, required: true },
  parentEntity: { type: Object, required: true },
  cardElementId: { type: String, required: true },
  boundedContext: { type: Object, default: null },
  refreshKey: { type: Number, default: 0 },
  showEntities: { type: Boolean, default: false },
  borderColor: { type: String, required: true }
})

const emit = defineEmits(['field-blur'])

const store = useStore()
const { getRelatedEntity } = useDomainModel()

const dataTypeLabel = (field) => {
  return DataTypeShortLabels[field.dataType] || ''
}
</script>

<style scoped>
.card-item-body {
  border-width: 1px;
  border-top-width: 8px;
  border-style: solid;
  width: 100%;
  font-size: 13px !important;
  border-bottom-left-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
}

.required-field {
  &::after {
    content: ' *';
  }

  &:focus::after {
    visibility: hidden;
  }
}

.data-type-label {
  font-size: 10px;
  color: var(--dark-1);
  font-weight: 500;
  margin-left: 2px;
  user-select: none;
  flex-shrink: 0;
}
</style>
